import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  doGetVoiceSettingDetail,
  doUpdateServiceVoiceSetting,
  getVoiceSettingDetail,
  setVoiceSettingDetail,
} from "stores/slices/voiceSetting";

import VoiceSettingForm from "components/forms/voiceSettingForm";

const VoiceSetting = forwardRef(function VoiceSetting(props, ref) {
  const { serviceIdSelected, voiceSettingFormRef, disabled } = props;
  const dispatch = useDispatch();
  const voiceSettingDetail = useSelector(getVoiceSettingDetail);
  const [dataForm, setDataForm] = useState({
    forward: false,
    voiceMessage: "",
    voiceMessageType: "",
    voiceOptionType: "",
  });

  const handleSubmit = async data => {
    setDataForm({ ...data });
  };

  useImperativeHandle(ref, () => ({
    updateVoiceSetting: serviceId => {
      handleUpdateVoiceSetting(serviceId, dataForm);
    },
  }));

  const handleGetVoiceSettingDetail = async () => {
    if (serviceIdSelected) {
      await dispatch(doGetVoiceSettingDetail({ serviceId: serviceIdSelected }));
    } else {
      await dispatch(setVoiceSettingDetail(null));
    }
  };

  const handleUpdateVoiceSetting = async (serviceId, data) => {
    if (serviceId && data) {
      await dispatch(
        doUpdateServiceVoiceSetting({
          ...data,
          id: serviceId,
        })
      );
    }
  };

  useEffect(() => {
    handleGetVoiceSettingDetail();
  }, [serviceIdSelected]);

  return (
    <>
      <VoiceSettingForm
        ref={voiceSettingFormRef}
        voiceSettingDetail={voiceSettingDetail}
        onSubmit={handleSubmit}
        disabled={disabled}
      />
    </>
  );
});

export default VoiceSetting;
